export default "__VITE_ASSET__DiJ2QdQr__"